import { Component, OnInit } from '@angular/core';
import { DialogConfig, DialogConfigData } from '@app/common/models/dialog-config';
import { DialogRef } from '@app/common/services/dialog-ref';
import { AttachmentTypeModel } from '@app/common/models/attachment-type.model';
import * as _ from 'lodash';
import { AttachmentTypePipe } from '@app/common/pipes/attachment-type.pipe';
import * as GMTCK from 'gmt-ckeditor/dist';
import { UploadFileExtended } from '@app/common/components/fileupload/fileupload.component';
import { DocumentModel } from '@app/common/models/document.model';
import { ComponentModel } from '@app/common/models/component.model';
import {FileUtils} from "@app/common/utils/file.utils";

export interface ComponentAddResult {
  documentName: string;
  files: UploadFileExtended[];
  attachmentType: AttachmentTypeModel;
  note: string;
}

@Component({
  selector: 'component-add',
  templateUrl: './component-add.component.html',
  styleUrls: ['component-add.component.scss']
})
export class ComponentAddComponent implements OnInit {

  static readonly MSG_FILES_DEFAULT = 'Vložte soubor přetažením nebo výběrem. Je možné vložit jeden soubor.';
  static readonly MSG_FILES_QUANTITY  = 'Je možné vložit pouze jeden soubor.';
  static readonly MSG_FILES_TYPE  = 'Soubor verze musí být stejného typu (xlsx, docx, pdf, ...).';

  // Kdyz je vyplnen dokument, tak jde o formular pro vkladani komponenty do dokumentu
  // Kdyz je vyplnena komponent, tak jde o formular pro novou verzi komponenty
  // Kdyz neni vyplneno ani jedno, tak jde o formular pro novy dokument

  document: DocumentModel;
  component: ComponentModel;

  documentName;
  attachmentTypes: AttachmentTypeModel[];
  attachmentType: AttachmentTypeModel;
  files: UploadFileExtended[] = [];
  filesMsg = ComponentAddComponent.MSG_FILES_DEFAULT;
  filesValid = false;
  editor;

  constructor(
    private dialogConfig: DialogConfig,
    public dialogComponent: DialogRef,
    public attachmentTypePipe: AttachmentTypePipe,
  ) {
    this.onSave = this.onSave.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  async ngOnInit() {
    this.document = (<DialogConfigData>this.dialogConfig.data).document;
    this.component = (<DialogConfigData>this.dialogConfig.data).component;
    const isCase = (<DialogConfigData>this.dialogConfig.data).isCase;
    this.attachmentTypes = _.cloneDeep(AttachmentTypeModel.getByCategory('component'))
      .filter(a =>
        !a.labels.includes('acquisitionDeed')
        && !['OPINION_SCAN_EXTERNAL', 'GEOMETRIC_PLAN_EXTERNAL'].includes(a.id)
        && (!isCase ? !['CONTRACT_EXTERNAL', 'COVERING_LETTER_EXTERNAL'].includes(a.id) : true)
      );
    await this.prepareEditor();
  }

  onFilesChanged(files: UploadFileExtended[]) {
    this.files = files;
    let extensionCheck = true;

    if (this.files.length === 0) {
      this.filesMsg = ComponentAddComponent.MSG_FILES_DEFAULT;
    } else if (this.files.length > 1) {
      this.filesMsg = ComponentAddComponent.MSG_FILES_QUANTITY;
    } else if (this.component && this.files[0].extension !== FileUtils.getFileExtension({ name: this.component.baseName })) {
      this.filesMsg = ComponentAddComponent.MSG_FILES_TYPE;
      extensionCheck = false;
    } else {
      this.filesMsg = '';
    }

    this.filesValid = (this.files.length === 1) && extensionCheck;
  }

  isValid() {
    if (!this.document && !this.component) {
      return this.documentName && this.filesValid && this.attachmentType;
    }

    if (this.document && this.component) {
      return this.filesValid;
    }

    if (this.document && !this.component) {
      return this.filesValid && this.attachmentType;
    }

    return false;
  }

  onSave() {
    this.dialogComponent.close({
      documentName: this.documentName,
      files: this.files,
      attachmentType: this.attachmentType,
      note: this.editor.getData()
    } as ComponentAddResult);
  }

  onCancel() {
    this.dialogComponent.close(false);
  }

  private async prepareEditor() {
    this.editor = await GMTCK.ClassicEditor.create(document.querySelector('#add-component-editor'));
  }
}
